import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { SocketIoModule } from 'ng-socket-io';

import { AclService } from 'ng2-acl/dist';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';

import { config } from './config';

import { AppComponent, ExportDialogComponent, ImportDialogComponent } from './app.component';
import { FuseMainModule } from './main/main.module';

import { DataService } from './services/data.service';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AppStoreModule } from './store/store.module';
import { FuseFakeDbService } from './fuse-fake-db/fuse-fake-db.service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { 
    MatDialogModule,
    MatButtonModule, 
    MatFormFieldModule, 
    MatIconModule, 
    MatMenuModule, 
    MatSelectModule, 
    MatDatepickerModule, 
    MatInputModule
    } from '@angular/material';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { FileDropModule } from 'ngx-file-drop';


const appRoutes: Routes = [
    { path: '', loadChildren: './main/content/dashboard/dashboard.module#DashboardModule' },
    { path: 'calendar', loadChildren: './main/content/calendar/calendar.module#CRMCalendarModule' },

    { path: 'leads', loadChildren: './main/content/leads/leads.module#LeadsModule' },
    { path: 'leads/:id', loadChildren: './main/content/leads/edit-lead/edit-lead.module#EditLeadModule' },
    { path: 'leads-legal', loadChildren: './main/content/leads-legal/leads-legal.module#LeadsLegalModule' },
    { path: 'leads-legal/:id', loadChildren: './main/content/leads-legal/edit-lead-legal/edit-lead-legal.module#EditLegalLeadModule' },

    { path: 'clients', loadChildren: './main/content/clients/leads.module#LeadsModule' },
    { path: 'clients/:id', loadChildren: './main/content/clients/edit-lead/edit-lead.module#EditLeadModule' },
    { path: 'clients-legal', loadChildren: './main/content/clients-legal/leads-legal.module#LeadsLegalModule' },
    { path: 'clients-legal/:id', loadChildren: './main/content/clients-legal/edit-lead-legal/edit-lead-legal.module#EditLegalLeadModule' },

    { path: 'copytrading', loadChildren: './main/content/copytrading/copytrading.module#CopytradingModule' },

    { path: 'tickets', loadChildren: './main/content/tickets/tickets.module#TicketsModule' },

    // { path: 'mail', loadChildren: './main/content/mail-ngrx/mail.module#FuseMailNgrxModule' },

    { path: 'bulk-emails', loadChildren: './main/content/mailing/bulk-emails/bulk-emails.module#BulkEmailsModule' },
    { path: 'mailing-templates', loadChildren: './main/content/mailing/mailing-templates/mailing-templates.module#MailingTemplatesModule' },
    { path: 'user-selections', loadChildren: './main/content/mailing/user-selections/user-selections.module#UserSelectionsModule' },
    { path: 'user-selections/edit/:id', loadChildren: './main/content/mailing/user-selections/edit-user-selection/edit-user-selection.module#EditUserSelectionModule' },
    { path: 'user-selections/create', loadChildren: './main/content/mailing/user-selections/create-user-selection/create-user-selection.module#CreateUserSelectionModule' },

    { path: 'profile', loadChildren: './main/content/profile/profile.module#ProfileModule' },
    { path: 'address-book', loadChildren: './main/content/address-book/address-book.module#AddressBookModule' },
    { path: 'settings', loadChildren: './main/content/settings/settings.module#SettingsModule' },
    { path: 'trading-account-details', loadChildren: './main/content/trading-account-details/trading-account-details.module#TradingAccountDetailsModule' },
    { path: 'auth', loadChildren: './main/content/auth/auth.module#AuthModule' },
    { path: 'payment-rates', loadChildren: './main/content/payment-rates/payment-rates.module#PaymentRatesModule' },
    { path: '**', redirectTo: '' },
];


@NgModule({
    declarations: [
        AppComponent,
        ExportDialogComponent,
        ImportDialogComponent
    ],
    entryComponents: [
        ExportDialogComponent,
        ImportDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppStoreModule,
        InMemoryWebApiModule.forRoot(FuseFakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),
        RouterModule.forRoot(appRoutes, { useHash: true }),
        TranslateModule.forRoot(),
        SocketIoModule,

        MatDialogModule,
        MatButtonModule, 
        MatFormFieldModule, 
        MatIconModule, 
        MatMenuModule, 
        MatSelectModule, 
        MatDatepickerModule, 
        MatInputModule,
        MatMomentDateModule,

        FormsModule,
        ReactiveFormsModule,
       
        // Fuse Main and Shared modules
        FuseModule.forRoot(config),
        FuseSharedModule,
        FuseMainModule,
        FileDropModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        DataService,
        AclService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule
{
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts